<template>
  <div>
    <div
      class="fixed inset-0 overflow-y-auto w-full h-full bg-white"
      style="z-index: 101"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div v-if="loading" class="h-screen flex justify-center items-center">
        <spinner />
      </div>
      <div v-else-if="errorMessage" class="alert alert-danger p-4">
        {{ errorMessage }}
      </div>
      <div
        v-else
        class="items-end justify-center min-h-screen text-center p-0 min-width-1300"
      >
        <BuyFreeProductModalVue
          v-if="buyFreeProduct"
          @close="buyFreeProduct = false"
          :orgId="orgId"
          :productId="productId"
        />
        <div class="text-white w-full relative bg-gray-50 height-366">
          <div
            class="cool absolute bg-white shadow border border-gray-200 rounded-md set-product-image-and-detail hide-product-price-and-detail"
          >
            <div class="image-style">
              <img
                :src="product.images[0]"
                class="product-image border border-gray-200 box-border"
              />
            </div>
            <div
              class="lg:ml-6 flex space-x-5 lg:mt-8 price-margin"
              v-if="price && couponId !== null"
            >
              <p class="text-gray-900 sm:text-3xl font-medium">
                {{ currency_icon }}{{ this.discounted_amount }}
              </p>
              <del class="text-gray-600 sm:font-normal sm:text-sm mt-2.5"
                >{{ currency_icon }}{{ productPrice }}
              </del>
            </div>
            <div class="lg:ml-6 flex space-x-5 lg:mt-8 price-margin" v-else>
              <!-- <p class="text-gray-900 sm:text-3xl  font-medium" v-if="price">{{currency_icon}}{{ productPrice }}</p> -->
              <p class="text-gray-900 sm:text-3xl font-medium">
                {{ productPriceDisplay }}
              </p>
            </div>
            <div class="mt-6">
              <button
                @click="buyProduct"
                type="button"
                :class="[
                  'inline-flex button-style theme-color justify-center items-center px-4 py-2 border border-transparent text-sm font-semibold rounded-md shadow-sm text-white',
                  !price ? 'disabled bg-gray-400 cursor-none' : '',
                ]"
              >
                <svg
                  v-if="isPaidProduct"
                  width="20"
                  height="16"
                  viewBox="0 0 20 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 6H19M5 11H6M10 11H11M4 15H16C17.6569 15 19 13.6569 19 12V4C19 2.34315 17.6569 1 16 1H4C2.34315 1 1 2.34315 1 4V12C1 13.6569 2.34315 15 4 15Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span :class="['inline-block', isPaidProduct ? 'ml-3' : '']">{{
                  btnText
                }}</span>
              </button>
            </div>
            <div class="text-align-start">
              <div
                class="flex w-full space-x-2 items-center justify-center mt-11"
              >
                <div>
                  <p
                    class="text-gray-500 sm:font-normal sm:text-xs coach-catalyst-text"
                  >
                    Powered by
                  </p>
                </div>
                <div>
                  <img
                    class="logo-design"
                    :src="require(`images/coachcatalyst_long 1.png`)"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="image-style hide-image">
            <img
              :src="product.images[0]"
              class="product-image border border-gray-200 box-border"
            />
          </div>
          <div
            class="title-design set-product-details padding-top text-align-start"
            v-if="product"
          >
            <div class="flex space-x-5">
              <div class="sm:mt-16">
                <img
                  class="h-8 w-8"
                  v-if="organization.logo_file_name !== null"
                  :src="organization.logo_url"
                />
                <Logo v-else class="h-8 w-8" type="icon" />
              </div>
              <div class="sm:mt-16">
                <p
                  class="text-gray-900 sm:font-medium sm:text-lg product-organization-name product-organization-margin"
                  v-if="organization"
                >
                  {{ organization.name }}
                </p>
              </div>
            </div>
            <div class="sm:mt-10 margin-top-20">
              <p
                class="text-gray-900 sm:font-semibold sm:text-3xl product-title"
              >
                {{ product.name }}
              </p>
            </div>
            <div v-if="product" class="sm:mt-5 margin-top-20">
              <p
                class="text-gray-900 font-normal sm:text-lg short-description-design text-width"
              >
                {{ product.description }}
              </p>
            </div>
          </div>
        </div>
        <div
          class="sm:mt-20 long-description-design set-product-details text-align-start padding-bottom"
          v-html="product.details"
          ref="htmlContainer"
        ></div>
        <div class="footer hide-footer">
          <div class="flex justify-between">
            <div class="flex space-x-2 pl-4 pt-6">
              <div v-if="price && couponId !== null" class="flex items-center">
                <p class="text-gray-900 price-text">
                  {{ currency_icon }}{{ this.discounted_amount }}
                </p>
                <del class="text-gray-600 font-normal text-base mt-1 ml-2"
                  >${{ productPrice }}
                </del>
              </div>
              <div v-else>
                <p class="text-gray-900 sm:text-3xl font-medium">
                  {{ productPriceDisplay }}
                </p>
                <!-- <p class="text-gray-900 price-text" v-if="price">{{ currency_icon }}{{ productPrice }}</p>
                                <p class="text-gray-900 price-text" v-else>No Price</p> -->
              </div>
            </div>
            <div class="mt-5 mr-4">
              <button
                type="button"
                @click="buyProduct"
                :class="[
                  'mb-2 inline-block product-page-button theme-color text-white font-medium text-xs leading-normal  rounded-md shadow-sm   focus:outline-none focus:ring-0 ease-in-out',
                  !price ? 'disabled bg-gray-400 cursor-none' : '',
                ]"
              >
                <svg
                  v-if="isPaidProduct"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3.5 10H21.5M7.5 15H8.5M12.5 15H13.5M6.5 19H18.5C20.1569 19 21.5 17.6569 21.5 16V8C21.5 6.34315 20.1569 5 18.5 5H6.5C4.84315 5 3.5 6.34315 3.5 8V16C3.5 17.6569 4.84315 19 6.5 19Z"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                {{ btnText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import ApiUrls from '../api-url';
  import BuyFreeProductModalVue from './shared/buy-free-product-modal.vue';
  import Spinner from '../general/spinner';
  import Logo from '../components/logos/Logo.vue';

  export default {
    name: 'product-landing-page',
    mixins: [ApiUrls],
    components: {
      BuyFreeProductModalVue,
      Spinner,
      Logo,
    },
    data() {
      return {
        product: null,
        price: null,
        organization: null,
        couponId: null,
        discounted_amount: null,
        buyFreeProduct: false,
        loading: false,
        errorMessage: '',
        orgId: null,
        productId: null,
      };
    },
    async created() {
      this.loading = true;
      await this.getIdsFromUrl();
      await this.getPromoCode();
      if (this.orgId && this.productId) {
        await this.getProduct();
        if (this.couponId) {
          await this.getCoupon();
        }
      }
      this.loading = false;
    },
    computed: {
      productPrice() {
        if (this.price.type === 'one_time') {
          return (this.price.unit_amount / 100).toFixed(2);
        } else {
          if (this.price.recurring && this.price.recurring.interval_count > 1) {
            return (
              (this.price.unit_amount / 100).toFixed(2) +
              ' / ' +
              this.price.recurring.interval_count +
              ' ' +
              this.price.recurring.interval +
              's'
            );
          } else {
            if (this.price && this.price.recurring) {
              return (
                (this.price.unit_amount / 100).toFixed(2) +
                ' / ' +
                this.price.recurring.interval
              );
            }
          }
        }
      },
      currency_icon() {
        return this.price.currency == 'usd'
          ? '$'
          : this.price.currency == 'cad'
          ? 'CA$'
          : this.price.currency == 'aud'
          ? 'A$'
          : this.price.currency == 'eur'
          ? '€'
          : this.price.currency == 'gbp'
          ? '£'
          : this.price.currency == 'nzd'
          ? 'NZ$'
          : '';
      },
      isPaidProduct() {
        return this.product && this.product.is_free == false;
      },
      productPriceDisplay() {
        if (this.isPaidProduct && this.price != null) {
          return `${this.currency_icon} ${this.productPrice}`;
        } else if (!this.isPaidProduct) {
          return 'Free';
        } else {
          return 'No Price';
        }
      },
      btnText() {
        return this.isPaidProduct ? 'Purchase' : 'Sign Up';
      },
    },
    methods: {
      showError(message) {
        this.errorMessage = message;
        this.loading = false;
      },
      async getProduct() {
        try {
          let body = {
            product_id: this.productId,
            organization_id: this.orgId,
          };

          let response = await axios.post(this.stripeUrl + 'get_product', body);

          if (response.data.success) {
            this.product = response.data.result.product;
            this.price = response.data.result.price;
            this.organization = response.data.organization;

            if (this.product.state === 'archived') {
              this.showError(
                'This product is no longer available. It may have been deleted.'
              );
              return;
            }
          } else {
            this.showError(
              response.data.message ||
                'Product not found. It may have been deleted or the link is incorrect'
            );
          }
        } catch (error) {
          if (error.response) {
            const status = error.response.status;
            if (status === 400) {
              this.showError('Invalid product ID format.');
            } else {
              this.showError(
                'Failed to load product. The the link may be incorrect.'
              );
            }
          }
          console.error('Error fetching product:', error);
        } finally {
          this.loading = false;
        }
      },
      async getCoupon() {
        let body = {
          organization_id: this.orgId,
          coupon_id: this.couponId,
        };
        let response = await axios.post(this.stripeUrl + 'get_coupon', body);
        if (response.data.success) {
          let coupon = response.data.coupon;
          if (coupon.amount_off !== null) {
            this.discounted_amount = (
              (this.price.unit_amount - coupon.amount_off) /
              100
            ).toFixed(2);
          }
          if (coupon.percent_off !== null) {
            let perecent = 1 - coupon.percent_off / 100;
            this.discounted_amount = (
              (perecent * this.price.unit_amount) /
              100
            ).toFixed(2);
          }
        }
      },
      async createCheckoutSession() {
        let coupon_id = null;
        if (this.$route.query.hasOwnProperty('promo')) {
          if (this.$route.query.promo !== '') {
            coupon_id = this.$route.query.promo;
          }
        }
        let body = {
          product: this.product,
          price: this.price,
          organization_id: this.orgId,
          coupon_id: coupon_id,
        };
        let response = await axios.post(
          this.stripeUrl + 'create_checkout_session',
          body
        );
        if (response.data.success) {
          window.location.href = response.data.result.url;
        }
      },
      buyProduct() {
        if (this.isPaidProduct) {
          this.createCheckoutSession();
        } else {
          this.buyFreeProduct = true;
        }
      },
      getIdsFromUrl() {
        const pathSegments = window.location.pathname.split('/');
        const orgIndex = pathSegments.findIndex(
          (segment) => segment === 'organization'
        );
        const productIndex = pathSegments.findIndex(
          (segment) => segment === 'products'
        );
        this.orgId =
          orgIndex !== -1 && orgIndex + 1 < pathSegments.length
            ? pathSegments[orgIndex + 1]
            : null;
        this.productId =
          productIndex !== -1 && productIndex + 1 < pathSegments.length
            ? pathSegments[productIndex + 1]
            : null;
      },
      getPromoCode() {
        this.couponId = new URLSearchParams(window.location.search).get(
          'promo'
        );
      },
    },
  };
</script>

<style scoped></style>
